import { render, staticRenderFns } from "./PlantaoPayment.vue?vue&type=template&id=326db06c"
import script from "./PlantaoPayment.vue?vue&type=script&lang=js"
export * from "./PlantaoPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports